import { useContext } from 'react';

import { UserDebugContext } from '../UserDebugContext';

export function useUserDebug() {
  const context = useContext(UserDebugContext);
  if (!context) {
    throw new Error('useUserDebug must be used within a UserDebugProvider');
  }
  return context;
}
